// export const imageBaseUrl = 'https://ik.imagekit.io/rbuba3kcz/';
export const imageBaseUrl = 'https://nvtvstorage.blob.core.windows.net/nvtv/';
// export const imageLiveBaseUrl = 'https://ik.imagekit.io/nvtv/';
export const imageLiveBaseUrl = 'https://nvtvstorage.blob.core.windows.net/nvtv/';
export const localAppUrl = 'https://api.nattuvartha.news/api';
export const demoAppUrl = 'https://nvtvapi.glidix.com/api';
export const liveAppUrl = 'https://api.nattuvartha.news/api';
export const localAppFEUrl = 'http://localhost:3000/';
export const demoAppFEUrl = 'https://nvtv.glidix.com/';
export const liveAppFEUrl = 'https://nattuvartha.news/';